let origin = "https://future.zhuneng.cn";
//提交捐赠
const postDonateUrl = `/gateway/hc-serve/miniapi/donate/donateApply`;
//我的捐赠
const myDonateUrl = `/gateway/hc-serve/miniapi/donate/myDonateList`;
//捐赠列表
const donateListUrl = `/gateway/hc-serve/miniapi/donate/donateList`;
//我的捐赠详情
const myDonateDetailUrl = `/gateway/hc-serve/miniapi/donate/myDonateDetail`;
//捐赠详情
const donateDetailUrl = `/gateway/hc-serve/miniapi/donate/donateDetail`;
//取消捐赠
const cancelUrl = `/gateway/hc-serve/miniapi/donate/myDonateCancel`;

export {
  postDonateUrl,
  myDonateUrl,
  donateListUrl,
  myDonateDetailUrl,
  donateDetailUrl,
  cancelUrl,
};
